import { AlertSection } from '../../../../../../shared/types/legalProceedings/alerts';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const useAlertsSection = (alertSection?: AlertSection) => {
    const formik = useFormik({
        initialValues: {
            alertDate: '',
            classification: '',
            numberDays: '',
            alertByMail: false,
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            alertDate: useGetNameOrValue(alertSection?.alertDate || ''),
            classification: useGetNameOrValue(
                alertSection?.classification || ''
            ),
            numberDays: alertSection?.numberDays || '',
            alertByMail: alertSection?.alertByMail || false,
        });
    }, [alertSection]);

    return {
        formik,
    };
};
